import { h, Host } from "@stencil/core";
import { ICON_NAMESPACE } from "../../../icons/namespace";
/**
 * A dropdown to display more actions than can be reasonably fit in a row.
 * All child actions must have the `dropdownItem` prop set.
 */
export class ESActionDropdown {
    constructor() {
        this.toggleDropdown = () => {
            this.dropdownOpen = !this.dropdownOpen;
        };
        this.closeDropdown = () => {
            this.dropdownOpen = false;
        };
        this.icon = [ICON_NAMESPACE, 'more'];
        this.disabled = false;
        this.dropdownOpen = false;
    }
    render() {
        return (h(Host, { key: '3c918cb29c1ee7ab594c96ff42d195ff163ecc6c' }, h("es-button", { key: '8f7172b3cb017ed6952f2444552b7dad2bb060f2', disabled: this.disabled, variant: 'minimal', onClick: this.toggleDropdown, onMouseDown: (e) => e.preventDefault() }, h("es-icon", { key: '2304b8c31cdf393fff57cf22394b0cc805d87e1b', icon: this.icon, size: 20 })), h("es-popover", { key: '8997dbd5fb9aac237cdd3e63333b9ef9261b74b2', arrow: true, trapFocus: true, closeOnEsc: true, closeOnClickOutside: true, closeOnBlur: true, onRequestClose: this.closeDropdown, open: this.dropdownOpen, placement: 'bottom-end', offset: 8 }, h("slot", { key: 'd4e025429d6a8e7d6f72463d29bce65daaf2dc2e' }))));
    }
    static get is() { return "es-action-dropdown"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["es-action-dropdown.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["es-action-dropdown.css"]
        };
    }
    static get properties() {
        return {
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconDescription",
                    "resolved": "[namespace: string | symbol, name: string] | string",
                    "references": {
                        "IconDescription": {
                            "location": "import",
                            "path": "../../es-icon/types",
                            "id": "src/components/es-icon/types.ts::IconDescription"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon to show for the action."
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "[ICON_NAMESPACE, 'more']"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If the dropdown should be disabled."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "dropdownOpen": {}
        };
    }
}
//# sourceMappingURL=es-action-dropdown.js.map
